import { c as _c } from "react-compiler-runtime";
import { forwardRef, useMemo } from 'react';
import { PropertiesProvider as CustomerDataPropertiesProvider } from 'customer-data-properties/context';
import UserInfoProvider from 'marketing-platform-lib/providers/UserInfoProvider';
import AsyncListingLibDevTools from 'framework-listing-lib/internal/DevTools/components/AsyncListingLibDevTools';
import useOpenDevTools from 'framework-listing-lib/internal/DevTools/hooks/useOpenDevTools';
import ErrorBoundary from 'framework-listing-lib/internal/ErrorBoundary';
import CurrentViewProvider from 'framework-listing-lib/internal/ViewTabs/providers/CurrentViewProvider';
import { PinnedViewsBarClientProvider } from 'framework-listing-lib/internal/ViewTabs/providers/PinnedViewsBarClientProvider';
import ViewsProvider from 'framework-listing-lib/internal/ViewTabs/providers/ViewsProvider';
import usePerformanceTracking from 'framework-listing-lib/internal/hooks/usePerformanceTracking';
import CrmObjectTypeListingClientProvider from 'framework-listing-lib/internal/providers/CrmObjectTypeListingClientProvider';
import DataProvider from 'framework-listing-lib/internal/providers/DataProvider';
import ListingProvider from 'framework-listing-lib/internal/providers/ListingProvider';
import PropertiesProvider from 'framework-listing-lib/internal/providers/PropertiesProvider';
import TrackerProvider from 'framework-listing-lib/internal/providers/TrackerProvider';
import { MEASURE_MARK_NAMES } from 'framework-listing-lib/internal/utils/performanceTracking';
import { SENTRY_KEYS } from 'framework-listing-lib/utils/sentry';
import { DataWellSlotProvider } from 'framework-listing-lib/internal/providers/DataWellSlotProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function FrameworkListingLibProvider(t0) {
  "use memo";

  const $ = _c(44);
  const {
    associationSpecs,
    calendarProps,
    children,
    emptyStateFilter,
    enableFieldLevelPermissions: t1,
    enableObjectLevelPermissions: t2,
    fetcher,
    folderProps,
    hiddenFilter,
    initialFilter,
    inlineEditProps,
    objectType,
    propertyOverride,
    typeDefinitionOverride,
    quickFilterProps,
    searchInputProps: _searchInputProps,
    trackerProps,
    uiModeProps,
    viewProps,
    showHighlySensitiveProperties,
    skipCrm,
    sortPropertyOverride,
    _useNonGqlCRMSearch
  } = t0;
  const enableFieldLevelPermissions = t1 === undefined ? false : t1;
  const enableObjectLevelPermissions = t2 === undefined ? false : t2;
  const [open] = useOpenDevTools();
  usePerformanceTracking(MEASURE_MARK_NAMES.LIFECYCLE);
  let t3;
  bb0: {
    if (_searchInputProps) {
      const t4 = typeof _searchInputProps.hasSearchInput === "boolean" ? _searchInputProps.hasSearchInput : true;
      let t5;
      if ($[0] !== _searchInputProps || $[1] !== t4) {
        t5 = Object.assign({}, _searchInputProps, {
          hasSearchInput: t4
        });
        $[0] = _searchInputProps;
        $[1] = t4;
        $[2] = t5;
      } else {
        t5 = $[2];
      }
      t3 = t5;
      break bb0;
    }
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = {
        hasSearchInput: true
      };
      $[3] = t4;
    } else {
      t4 = $[3];
    }
    t3 = t4;
  }
  const searchInputProps = t3;
  const t4 = uiModeProps ? uiModeProps.onChangeUIMode : undefined;
  let t5;
  if ($[4] !== open) {
    t5 = open && /*#__PURE__*/_jsx(AsyncListingLibDevTools, {});
    $[4] = open;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== children || $[7] !== t4 || $[8] !== t5) {
    t6 = /*#__PURE__*/_jsxs(ViewsProvider, {
      onChangeUIMode: t4,
      children: [t5, children]
    });
    $[6] = children;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== associationSpecs || $[11] !== calendarProps || $[12] !== emptyStateFilter || $[13] !== fetcher || $[14] !== folderProps || $[15] !== hiddenFilter || $[16] !== initialFilter || $[17] !== inlineEditProps || $[18] !== quickFilterProps || $[19] !== searchInputProps || $[20] !== t6) {
    t7 = /*#__PURE__*/_jsx(CurrentViewProvider, {
      children: /*#__PURE__*/_jsx(DataWellSlotProvider, {
        children: /*#__PURE__*/_jsx(CrmObjectTypeListingClientProvider, {
          associationSpecs: associationSpecs,
          calendarProps: calendarProps,
          emptyStateFilter: emptyStateFilter,
          fetcher: fetcher,
          folderProps: folderProps,
          hiddenFilter: hiddenFilter,
          initialFilter: initialFilter,
          inlineEditProps: inlineEditProps,
          quickFilterProps: quickFilterProps,
          searchInputProps: searchInputProps,
          children: t6
        })
      })
    });
    $[10] = associationSpecs;
    $[11] = calendarProps;
    $[12] = emptyStateFilter;
    $[13] = fetcher;
    $[14] = folderProps;
    $[15] = hiddenFilter;
    $[16] = initialFilter;
    $[17] = inlineEditProps;
    $[18] = quickFilterProps;
    $[19] = searchInputProps;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== showHighlySensitiveProperties || $[23] !== t7) {
    t8 = /*#__PURE__*/_jsx(DataProvider, {
      showHighlySensitiveProperties: showHighlySensitiveProperties,
      children: t7
    });
    $[22] = showHighlySensitiveProperties;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== propertyOverride || $[26] !== sortPropertyOverride || $[27] !== t8 || $[28] !== typeDefinitionOverride) {
    t9 = /*#__PURE__*/_jsx(PropertiesProvider, {
      propertyOverride: propertyOverride,
      sortPropertyOverride: sortPropertyOverride,
      typeDefinitionOverride: typeDefinitionOverride,
      children: t8
    });
    $[25] = propertyOverride;
    $[26] = sortPropertyOverride;
    $[27] = t8;
    $[28] = typeDefinitionOverride;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  let t10;
  if ($[30] !== _useNonGqlCRMSearch || $[31] !== enableObjectLevelPermissions || $[32] !== objectType || $[33] !== skipCrm || $[34] !== t9 || $[35] !== uiModeProps || $[36] !== viewProps) {
    t10 = /*#__PURE__*/_jsx(PinnedViewsBarClientProvider, {
      children: /*#__PURE__*/_jsx(ListingProvider, {
        enableObjectLevelPermissions: enableObjectLevelPermissions,
        objectType: objectType,
        uiModeProps: uiModeProps,
        viewProps: viewProps,
        skipCrm: skipCrm,
        _useNonGqlCRMSearch: _useNonGqlCRMSearch,
        children: t9
      })
    });
    $[30] = _useNonGqlCRMSearch;
    $[31] = enableObjectLevelPermissions;
    $[32] = objectType;
    $[33] = skipCrm;
    $[34] = t9;
    $[35] = uiModeProps;
    $[36] = viewProps;
    $[37] = t10;
  } else {
    t10 = $[37];
  }
  let t11;
  if ($[38] !== enableFieldLevelPermissions || $[39] !== t10) {
    t11 = /*#__PURE__*/_jsx(CustomerDataPropertiesProvider, {
      enableFieldLevelPermissions: enableFieldLevelPermissions,
      children: t10
    });
    $[38] = enableFieldLevelPermissions;
    $[39] = t10;
    $[40] = t11;
  } else {
    t11 = $[40];
  }
  let t12;
  if ($[41] !== t11 || $[42] !== trackerProps) {
    t12 = /*#__PURE__*/_jsx(ErrorBoundary, {
      fingerprint: SENTRY_KEYS.TOP_LEVEL_LIB_PROVIDER,
      children: /*#__PURE__*/_jsx(UserInfoProvider, {
        children: /*#__PURE__*/_jsx(TrackerProvider, Object.assign({}, trackerProps, {
          children: t11
        }))
      })
    });
    $[41] = t11;
    $[42] = trackerProps;
    $[43] = t12;
  } else {
    t12 = $[43];
  }
  return t12;
}
export default $hasDep('react-dnd', '5') ? FrameworkListingLibProvider :
// eslint-disable-next-line @typescript-eslint/no-var-requires
require('customer-data-ui-utilities/dnd/SharedDragDropContext').default()( /*#__PURE__*/forwardRef((props, __ref) => {
  "use memo";

  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = /*#__PURE__*/_jsx(FrameworkListingLibProvider, Object.assign({}, props));
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}));